"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../../io/codec");
var serialiser_1 = require("./../../../serialisers/serialiser");
/**
 * Serialiser for {@link GatewayServiceId}
 */
var GatewayServiceIdSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayServiceIdSerialiserClass, _super);
    function GatewayServiceIdSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayServiceId} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayServiceId} that was read
     */
    GatewayServiceIdSerialiserClass.prototype.read = function (bis) {
        var type = Codec.readString(bis);
        var name = Codec.readString(bis);
        return {
            type: type,
            name: name
        };
    };
    /**
     * Write a {@link GatewayServiceId} from the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayServiceId} to write
     */
    GatewayServiceIdSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.type);
        Codec.writeString(bos, value.name);
    };
    return GatewayServiceIdSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayServiceIdSerialiserClass = GatewayServiceIdSerialiserClass;
/**
 * The {@link GatewayServiceIdSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayServiceIdSerialiser = new GatewayServiceIdSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/service-id-serialiser.js
// module id = 524
// module chunks = 1